import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import App from './App';
import TestApp from './TestApp';

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  devMode: true
});

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  console.log('Restoring original URI:', originalUri);
  const targetUri = toRelativeUrl(originalUri || '/', window.location.origin);
  console.log('Target URI:', targetUri);
  window.location.replace(targetUri);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <App />
    </Security>
  </BrowserRouter>
);